import { jsx } from '@emotion/react/jsx-runtime';
import { Button } from './Button.esm.js';
import { FarawayIconInShape } from '../icons/farawayIconInShape.esm.js';
import 'react';
import './Spinner.esm.js';
import '@emotion/styled/base';
import '../Typography-d24bab8f.js';
import '../clsx.m-2bb6df4b.js';
import '../constants/breakpoints.constants.esm.js';
import '@emotion/react';
import '../icons/farawayIcon.esm.js';

const ContinueWithFarawayButton = (props) => {
  return /* @__PURE__ */ jsx(Button, { size: "small", leftIcon: /* @__PURE__ */ jsx(FarawayIconInShape, { wrapperProps: {
    style: {
      backgroundColor: "var(--light-background-main)"
    }
  }, svgProps: {
    color: "var(--dark-background-main)"
  } }), colorScheme: "white", ...props, children: "Continue with Faraway" });
};

export { ContinueWithFarawayButton };
//# sourceMappingURL=ContinueWithFarawayButton.esm.js.map
